export const PEDIDO_INGRESO_ORIGEN_MARKER_RE =
  /\[\[origen:([a-z0-9_]+)(?:;conv:([0-9]+))?(?:;fin:([^;\]]+))?\]\]/gi;

export const PEDIDO_INGRESO_ORIGEN_META = {
  call_center_crm: {
    label: 'Call Center',
    tag: 'Ingresado desde Call Center',
    short: 'Call Center',
    chip: 'WhatsApp CRM',
    title: 'Derivación ingresada por operador desde Conversaciones (WhatsApp CRM)'
  }
};

export function parsePedidoIngresoOrigen(notas) {
  const raw = String(notas || '');
  const match = raw.match(
    /^\[\[origen:([a-z0-9_]+)(?:;conv:([0-9]+))?(?:;fin:([^;\]]+))?\]\]\s*/i
  );
  if (!match) {
    return {
      ingreso_origen: null,
      ingreso_conversation_id: null,
      ingreso_finalized_at: null,
      notas_display: stripOrigenMarkerFromText(raw)
    };
  }
  return {
    ingreso_origen: match[1],
    ingreso_conversation_id: match[2] || null,
    ingreso_finalized_at: match[3] || null,
    notas_display: stripOrigenMarkerFromText(raw.slice(match[0].length))
  };
}

/** Quita markers [[origen:...]] sueltos para que no aparezcan en la UI. */
export function stripOrigenMarkerFromText(text) {
  return String(text || '')
    .replace(PEDIDO_INGRESO_ORIGEN_MARKER_RE, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/** Notas visibles: sin marker; si solo había marker, queda vacío (el tag va aparte). */
export function resolvePedidoNotasDisplay(notas, ingresoOrigen) {
  const parsed = parsePedidoIngresoOrigen(notas);
  if (ingresoOrigen || parsed.ingreso_origen) {
    return parsed.notas_display;
  }
  return parsed.notas_display || stripOrigenMarkerFromText(notas);
}

export function getPedidoIngresoOrigenMeta(origen) {
  const key = String(origen || '').trim().toLowerCase();
  return PEDIDO_INGRESO_ORIGEN_META[key] || null;
}

/** Evita mostrar el mismo bloque en notas y en "Registro de atención". */
export function notasTextWithoutInternalDuplicate(notasText, internalMessages) {
  const raw = String(notasText || '').trim();
  if (!raw || !Array.isArray(internalMessages) || !internalMessages.length) return raw;
  const norm = (s) => String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const n = norm(raw);
  const dup = internalMessages.some((m) => {
    const t = norm(m?.text);
    return t && (t === n || t.includes(n) || n.includes(t));
  });
  return dup ? '' : raw;
}
